import { Component, type ErrorInfo, type ReactNode } from 'react';

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[presentation] AppErrorBoundary', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="App-bootstrap App-bootstrap--error">
        <p>Что-то пошло не так.</p>
        <button
          type="button"
          className="App-bootstrap__retry"
          onClick={() => {
            window.location.reload();
          }}
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
